/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./MsgInfo.vue?vue&type=template&id=c82118a0&scoped=true&"
import script from "./MsgInfo.vue?vue&type=script&lang=js&"
export * from "./MsgInfo.vue?vue&type=script&lang=js&"
import style0 from "./MsgInfo.vue?vue&type=style&index=0&id=c82118a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c82118a0",
  null
  
)

export default component.exports